module.exports = __webpack_public_path__ + "img/lock-fail.ce111604.svg";